import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import React, { useState, useEffect, useRef } from 'react';

type TimerProps = {
  start: boolean;
  stop: boolean;
  resetKey: number;
  width?: string;
  height?: string;
  onScoreChange: (score: number) => void; // add this line
};

const Timer = ({ start = false, stop = false, resetKey, width = '100px', height = '100px', onScoreChange }: TimerProps) => {
  const [secondsLeft, setSecondsLeft] = useState(15);
  const [score, setScore] = useState(0);
  const scoreRef = useRef(score);
  const secondsLeftRef = useRef(secondsLeft);
  const interval = useRef<NodeJS.Timeout | null>(null);


  function resetTimer() {
    secondsLeftRef.current = 15;
    setSecondsLeft(secondsLeftRef.current);
  }

  function resetScore() {
    scoreRef.current = 800;
    setScore(scoreRef.current);
  }

  function tick() {
    secondsLeftRef.current--;
    scoreRef.current -= 53.39;
    setSecondsLeft(secondsLeftRef.current);
    setScore(scoreRef.current);
  }

  useEffect(() => {
    resetTimer();
    resetScore();
  }, [resetKey]);

  useEffect(() => {
    if (start && !stop) {
      interval.current = setInterval(() => {
        if (secondsLeftRef.current === 0) {
          clearInterval(interval.current as NodeJS.Timeout);
        } else {
          tick();
        }
      }, 1000);
    } else {
      clearInterval(interval.current as NodeJS.Timeout);
      if(stop) {
        onScoreChange(scoreRef.current);
      }
    }
    return () => clearInterval(interval.current as NodeJS.Timeout);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, stop]);

  useEffect(() => {
    console.log(score);
    // onScoreChange(score);
  }, [score]);

  const percentage = Math.round((secondsLeft / 15) * 100);

  return (
    <div style={{ width: width, height: height }}>
      <CircularProgressbar
        value={percentage}
        text={secondsLeft.toString()}
        styles={buildStyles({
          textColor: '#fff',
          pathColor: '#f54e4e',
          trailColor: 'rgba(255,255,255,.2)',
        })}
      />
    </div>
  );
};

export default Timer;
